import React, { Component, Fragment } from 'react';
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import {required, isValidForm} from '../../../util/validationMethods.js';

class TowTypeRec extends Component {
    constructor() {
        super();        
        this.handleSubmit = this.handleSubmit.bind(this);
        this.checkAccess = this.checkAccess.bind(this);
    }
    
    handleSubmit = (event) => {
        event.preventDefault();
        this.form.validateAll();
        
        if (!isValidForm(this.form)) {
            // Form has validation errors
        } else {
            this.props.onSubmitForm(event, this.props.recData)
        }
    }
    
    checkAccess = () => {
        // Disable form if it's a global tow type
        if (this.props.recData.isGlobal) {
            return true; // Disabled
        }
        
        // Check add/edit permissions
        if ((this.props.recData.towTypeId || 0) === 0) {
            // Adding new tow type
            return !(this.props.accessLevel.basicAccess.add || false);
        } else {
            // Editing existing tow type
            return !(this.props.accessLevel.basicAccess.edit || false);
        }
    }
    
    render() {
        const isGlobal = this.props.recData.isGlobal || false;
        const isDisabled = this.checkAccess();
        
        return (
            <Form ref={c => { this.form = c }} onSubmit={this.handleSubmit}>        
                <div className="modal-body">
                    {isGlobal && (
                        <div className="alert alert-info" role="alert">
                            <i className="fa fa-info-circle"></i> 
                            <strong> Global Tow Type:</strong> This is a system-defined tow type and cannot be edited or deleted.
                        </div>
                    )}
                    
                    <fieldset disabled={isDisabled}>
                        <div className="col-md-12 col-sm-12">
                            <div className="form-group">
                                <label className="form-control-label">
                                    Tow Type Name *
                                </label>
                                <Input 
                                    name="towType" 
                                    type="text" 
                                    className="form-control"  
                                    placeholder="Enter Tow Type Name"
                                    requiredmsg="Please enter Tow Type Name" 
                                    value={this.props.recData.towType} 
                                    onChange={(e) => {
                                        let _recObj = {...this.props.recData};
                                        _recObj[e.currentTarget.name] = e.currentTarget.value;
                                        this.props.onFieldDataChange(e, _recObj);
                                    }} 
                                    validations={[required]} 
                                />					
                            </div>
                        </div>
                    </fieldset>
                    
                    <div className="modal-footer">
                        <button 
                            type="button"
                            className="btn btn-danger btn-sm" 
                            onClick={(e) => {this.props.onCancelForm(e)}}>
                            Close
                        </button>
                        <button 
                            type="submit" 
                            className="btn btn-success btn-sm"
                            disabled={isDisabled}>
                            {(this.props.recData.towTypeId || 0) === 0 ? "Save" : "Save changes"}
                        </button>
                    </div>
                </div>
            </Form>
        )
    }
}

export default TowTypeRec